import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import * as sweetalert from "sweetalert";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Grid } from "@material-ui/core";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function Create() {
  const navigate = useNavigate();
  const [Fundoption, setFundoption] = useState([]);
  const [providerMTN1, setproviderMTN1] = useState([]);
  const [providerSyriatel1, setproviderSyriatel1] = useState([]);
  const [Staffoption, setStaffoption] = useState([]);
  const [staff, setStaff] = useState([]);
  const [providerSyriatel, setProviderSyriatel] = useState([]);
  const [providerMTN, setProviderMTN] = useState([]);
  const [Countries, setCountries] = useState([]);
  const [city, setCity] = useState([]);
  const [zone, setZone] = useState([]);
  const [city_id, setcity_id] = useState("1");
  const [loading, setLoading] = useState(false);

  const [city_id2, setcity_id2] = useState({
    city_id: {
      value: "",
    },
  });
  const handleSubmit1 = (e) => {
    e.preventDefault();
    axios
      .get(`${BaseUrl}/api/country/${city_id}/city/${city_id2.city_id}/zones`, {
        withCredentials: true,
      })
      .then((resZone) => {
        setZone(resZone.data.data);
      });
  };
  const initialFValues = {
    first_name: "",
    last_name: "",
    father_name: "",
    mother_name: "",
    mobile_number: "",
    id_number: "",
    password: "",
    address: "",
    password_confirmation: "",
    staff_type: "",
    id_photo1: "",
    id_photo2: "",
    personal_photo: "",
    city_id: "",
    zone_id: "",
    provider_id: "",
    distributor_id: "",
  };

  useEffect(() => {

    axios
      .get(`${BaseUrl}/api/GetStaffType`, {
        withCredentials: true,
      })
      .then((res) => {
        setStaff(res.data.data);
      });
    axios
      .get(`${BaseUrl}/api/providers`, {
        withCredentials: true,
      })
      .then((res) => {
        setProviderSyriatel(res.data.data);
      });
    axios
      .get(`${BaseUrl}/api/distributors`, {
        withCredentials: true,
      })
      .then((res) => {
        setProviderMTN(res.data.data);
      });
      
  }, []);
  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/country/1/cities`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setCity(
           res.data.data

        );
      })
      .catch((err) => {});
  }, []);
  const handelcity = (e) => {
    e.persist();
    setcity_id2({ ...city_id2, [e.target.name]: e.target.value });
    setLogin({ ...loginInput, city_id: e.target.value });
    axios
      .get(`${BaseUrl}/api/country/${city_id}/city/${e.target.value}/zones`, {
        withCredentials: true,
      })
      .then((resZone) => {
        setZone(resZone.data.data);
      });
  };

  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("first_name" in fieldValues)
      temp.first_name = fieldValues.first_name ? "" : "الاسم الأول مطلوب";

    if ("last_name" in fieldValues)
      temp.last_name = fieldValues.last_name ? "" : "الكنية  مطلوبة";

    if ("father_name" in fieldValues)
      temp.father_name = fieldValues.father_name ? "" : "اسم الأب مطلوب";

    if ("mother_name" in fieldValues)
      temp.mother_name = fieldValues.mother_name ? "" : "اسم الأم مطلوب";
    if ("city_id" in fieldValues)
      temp.city_id = fieldValues.city_id ? "" : "الحقل مطلوب";
    if ("zone_id" in fieldValues)
      temp.zone_id = fieldValues.zone_id ? "" : "الحقل مطلوب";
    if ("staff_type" in fieldValues)
      temp.staff_type = fieldValues.staff_type ? "" : "الحقل مطلوب";

    if ("mobile_number" in fieldValues) {
      if (fieldValues.mobile_number === "") {
        temp.mobile_number = "هذا الحقل مطلوب";
      } else if (!/^[0-9]+$/.test(fieldValues.mobile_number)) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.mobile_number.length !== 10) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      } else {
        temp.mobile_number = "";
      }
    }

    if ("id_number" in fieldValues) {
      if (fieldValues.id_number == "") {
        temp.id_number = " الرقم الوطني مطلوب";
      } else if (!/[0-9]/.test(fieldValues.id_number)) {
        temp.id_number = "يجب أن يكون الرقم الوطني أرقام";
      } else if (fieldValues.id_number.length !== 11) {
        temp.id_number = "يجب أن يكون رقم الوطني 11 رقمًا";
      } else {
        temp.id_number = "";
      }
    }

    if ("password" in fieldValues) {
      if (fieldValues.password == "") {
        temp.password = "كلمة السر مطلوبة";
      } else if (
        fieldValues.password.length < 8 ||
        !/[A-Z]/.test(fieldValues.password) ||
        !/[a-z]/.test(fieldValues.password) ||
        !/\d/.test(fieldValues.password) ||
        !/[@#$%^&+=]/.test(fieldValues.password)
      ) {
        temp.password =
          "يجب أن تكون كلمة السر مؤلفة من 8 محارف وتحوي أحرف صغيرة وكبيرة ورموز وأرقام";
      } else {
        temp.password = "";
      }
    }

    if ("password_confirmation" in fieldValues) {
      if (fieldValues.password_confirmation == "") {
        temp.password_confirmation = "كلمة السر مطلوبة";
      } else if (
        fieldValues.password_confirmation.length < 8 ||
        !/[A-Z]/.test(fieldValues.password_confirmation)
      ) {
        temp.password_confirmation =
          "يجب أن تكون كلمة السر مؤلفة من 8 محارف وتحوي أحرف صغيرة وكبيرة ورموز وأرقام";
      } else if (fieldValues.password_confirmation !== loginInput.password) {
        temp.password_confirmation = "يجب أن تكون مطابقة لكلمة السر";
      } else {
        temp.password_confirmation = "";
      }
    }

    if ("id_photo1" in fieldValues) {
      if (fieldValues.id_photo1) {
        const fileSize = fieldValues.id_photo1.size / 1024; // حجم الملف بالكيلوبايت
        if (fileSize > 512) {
          temp.id_photo1 = "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت";
        } else {
          temp.id_photo1 = "";
        }
      } else {
        temp.id_photo1 = "هذا الحقل مطلوب";
      }
    }

    if ("id_photo2" in fieldValues) {
      if (fieldValues.id_photo2) {
        const fileSize = fieldValues.id_photo2.size / 1024; // حجم الملف بالكيلوبايت
        if (fileSize > 512) {
          temp.id_photo2 = "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت";
        } else {
          temp.id_photo2 = "";
        }
      } else {
        temp.id_photo2 = "هذا الحقل مطلوب";
      }
    }

    if ("personal_photo" in fieldValues) {
      if (fieldValues.personal_photo) {
        const fileSize = fieldValues.personal_photo.size / 1024; // حجم الملف بالكيلوبايت
        if (fileSize > 512) {
          temp.personal_photo = "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت";
        } else {
          temp.personal_photo = "";
        }
      } else {
        temp.personal_photo = "هذا الحقل مطلوب";
      }
    }

    if ("distributor_id" in fieldValues)
      temp.distributor_id = fieldValues.distributor_id ? "" : "هذا الحقل مطلوب";
    if ("provider_id" in fieldValues)
      temp.provider_id = fieldValues.provider_id ? "" : "هذا الحقل مطلوب";

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };

  const validate2 = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile_number" in fieldValues) {
      if (
        fieldValues.mobile_number !== "" &&
        !/^[0-9]+$/.test(fieldValues.mobile_number)
      ) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (
        fieldValues.mobile_number !== "" &&
        fieldValues.mobile_number.length !== 10
      ) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      } else {
        temp.mobile_number = "";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    handlefile,
    addForm,
  } = useForm(initialFValues, true, validate, validate2);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      try {
        const bodyFormData = new FormData();
        bodyFormData.append("first_name", loginInput.first_name);
        bodyFormData.append("last_name", loginInput.last_name);
        bodyFormData.append("father_name", loginInput.father_name);
        bodyFormData.append("address", loginInput.address);
        bodyFormData.append("mother_name", loginInput.mother_name);
        bodyFormData.append("mobile_number", loginInput.mobile_number);
        bodyFormData.append("id_number", loginInput.id_number);
        bodyFormData.append("password", loginInput.password);
        bodyFormData.append(
          "password_confirmation",
          loginInput.password_confirmation
        );
        bodyFormData.append("staff_type", Staffoption);
        bodyFormData.append("personal_photo", loginInput.personal_photo);
        bodyFormData.append("id_photo1", loginInput.id_photo1);
        bodyFormData.append("id_photo2", loginInput.id_photo2);
        bodyFormData.append("city_id", city_id2.city_id);
        bodyFormData.append("zone_id", Fundoption);

        const response = await axios.post(
          `${BaseUrl}/api/storeStaffAdmin`,
          bodyFormData,
          {
            withCredentials: true,
          }
        );

        if (response.status === 200) {
          sweetalert("تم إضافة مستخدم بنجاح", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          }).then(() => {
            navigate("/staff");
          });

          const dataMTN = {
            staff_id: response.data.id,
            distributor_id: providerMTN1,
          };

          axios.post(`${BaseUrl}/api/assignDistributorCodeToStaff`, dataMTN, {
            withCredentials: true,
          });

          const dataSyriatel = {
            staff_id: response.data.id,
            provider_id: providerSyriatel1,
          };

          axios.post(`${BaseUrl}/api/assignGsmToStaff`, dataSyriatel, {
            withCredentials: true,
          });
          setLoading(false);
        } else {
          // Handle other HTTP statuses or unexpected errors
          sweetalert("An unexpected error occurred", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
        }
      } catch (error) {
        // Handle errors from the try block
        if (error.response && error.response.status === 422) {
          // Handle specific case for 422 Unprocessable Entity
          const errorMessages = [];

          // Iterate through the data object and extract error messages
          for (const key in error.response.data.data) {
            if (
              error.response.data.data.hasOwnProperty(key) &&
              error.response.data.data[key].length > 0
            ) {
              // Add each error message to the array
              errorMessages.push(error.response.data.data[key][0]);
            }
          }
          if (errorMessages.length > 0) {
            setLoading(false);
            sweetalert(errorMessages.join("\n"), {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          } else {
            // Display a generic error message if no specific errors are found
            setLoading(false);
            sweetalert(error.response.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          }
          setLoading(false);
          sweetalert(errorMessages.join("\n"), {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
        } else {
          if (error.response && error.response.status === 500) {
            sweetalert(error.response.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          }

          setLoading(false);
          sweetalert("An unexpected error occurred", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
        }
      }
    }
  };

  const handelMTN = (e) => {
    setproviderMTN1(e.target.value);
    setLogin({ ...loginInput, distributor_id: e.target.value });
  };
  const handelSyriatel = (e) => {
    setproviderSyriatel1(e.target.value);
    setLogin({ ...loginInput, provider_id: e.target.value });
  };
  const handelStaff = (e) => {
    setStaffoption(e.target.value);
    setLogin({ ...loginInput, staff_type: e.target.value });
  };
  const handelZone = (e) => {
    setFundoption(e.target.value);
    setLogin({ ...loginInput, zone_id: e.target.value });
  };
  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }));
  useEffect(() => {
    validate2(loginInput);
  }, [loginInput]);

  useEffect(() => {
    if (loading === true && !validate()) {
      setTimeout(() => {
        // After the timeout, reset the loading state
        setLoading(false);
        // Your other logic here
      }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);

  return (
    <div className="main-div">
      <h3 className="titlepage">إنشاء مستخدم</h3>

      <Form
        className="form-group new-design"
        method="post"
        enctype="multipart/form-data"
        onSubmit={handleSubmit}
      >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label=" اسم الأول"
              name="first_name"
              fullWidth
              required
              onChange={handleInputChange}
              className="form-control"
              error={errors.first_name}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="الكنية"
              required
              name="last_name"
              variant="outlined"
              fullWidth
              onChange={handleInputChange}
              className="form-control"
              error={errors.last_name}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="اسم الأب"
              name="father_name"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              className="form-control"
              error={errors.father_name}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="اسم الأم"
              name="mother_name"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              className="form-control"
              error={errors.mother_name}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="رقم الموبايل"
              name="mobile_number"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              className="form-control"
              error={errors.mobile_number}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="الرقم الوطني"
              name="id_number"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              className="form-control"
              error={errors.id_number}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="كلمة المرور"
              name="password"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              className="form-control"
              error={errors.password}
              type="password"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="تأكيد كلمة المرور"
              name="password_confirmation"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              className="form-control"
              error={errors.password_confirmation}
              type="password"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="العنوان التفصيلي"
              name="address"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              className="form-control"
              error={errors.father_name}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              placeholder="الرجاءإدخال صورة الهوية  صورة الأمامية"
              className="form-control"
              label="صورة الهوية الأمامية"
              name="id_photo1"
              variant="outlined"
              fullWidth
              required
              type="file"
              onChange={handlefile}
              error={errors.id_photo1}
            />
            <div style={{ color: "red", fontSize: "10px", textAlign: "end" }}>
              {errors.id_photo1}
            </div>
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              placeholder="الرجاءإدخال صورة الهوية  صورة الخلفية"
              className="form-control"
              label="صورة الهوية الخلفية"
              name="id_photo2"
              variant="outlined"
              fullWidth
              required
              type="file"
              onChange={handlefile}
              error={errors.id_photo2}
            />

            <div style={{ color: "red", fontSize: "10px", textAlign: "end" }}>
              {errors.id_photo2}
            </div>
          </Grid>

          <Grid item md={6} xs={12}>
            <TextField
              placeholder="الرجاءإدخال  لوغو نقطة البيع"
              className="form-control"
              label="لوغو نقطة البيع"
              name="personal_photo"
              variant="outlined"
              fullWidth
              required
              type="file"
              onChange={handlefile}
              error={errors.personal_photo}
            />
            <div style={{ color: "red", fontSize: "10px", textAlign: "end" }}>
              {errors.personal_photo}
            </div>
          </Grid>

          <Grid item md={6} xs={12}>
            <div class="select">
              <select
                selected
                class="select-text"
                name="staff_type"
                onChange={(e) => handelStaff(e)}
                error={errors.staff_type}
              >
                <option selected disabled className="title-option">
                  اختر النوع
                </option>
                {staff.map((opts, i) => (
                  <option key={i} value={opts.en_name}>
                    {opts.ar_name}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <label class="select-label"> نوع التحويل</label>
            </div>
            {loginInput.staff_type == "" ? (
              <div style={{ color: "red", fontSize: "10px", textAlign: "end" }}>
                {errors.staff_type}
              </div>
            ) : (
              <></>
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="select">
              <select
                required
                onChange={handelcity}
                name="city_id"
                class="select-text"
              >
                <option selected disabled className="title-option">
                  اختر المحافظة
                </option>
                {city.map((opts, i) => (
                  <option key={i} onClick={handleSubmit1} value={opts.id}>
                    {opts.name_ar}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <label class="select-label">المحافظة</label>
            </div>
            {loginInput.city_id == "" ? (
              <div style={{ color: "red", fontSize: "10px", textAlign: "end" }}>
                {errors.city_id}
              </div>
            ) : (
              <></>
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="select">
              <select
                required="true"
                lect
                selected
                class="select-text"
                me="zone_id"
                onChange={(e) => handelZone(e)}
              >
                <option selected disabled className="title-option">
                  اختر المنطقة
                </option>
                {zone.map((opts, i) => (
                  <option key={opts.id} value={opts.id}>
                    {opts.name}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <label class="select-label">المنطقة</label>
            </div>
            {loginInput.zone_id == "" ? (
              <div style={{ color: "red", fontSize: "10px", textAlign: "end" }}>
                {errors.zone_id}
              </div>
            ) : (
              <></>
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="select">
              <select
                selected
                class="select-text"
                name="provider_id"
                onChange={(e) => handelSyriatel(e)}
              >
                <option selected disabled className="title-option">
                  نقطة بيع Syriatel
                </option>
                {providerSyriatel.map((opts, i) => (
                  <option key={opts.id} value={opts.id}>
                    {opts.gsm} -{opts.OwnerProvider}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <label class="select-label"> نوع التحويل</label>
            </div>
            {loginInput.provider_id == "" ? (
              <div style={{ color: "red", fontSize: "10px", textAlign: "end" }}>
                {errors.provider_id}
              </div>
            ) : (
              <></>
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="select">
              <select
                selected
                class="select-text"
                name="distributor_id"
                onChange={(e) => handelMTN(e)}
              >
                <option selected disabled className="title-option">
                  نقطة بيع MTN
                </option>
                {providerMTN.map((opts, i) => (
                  <option key={opts.id} value={opts.id}>
                    {opts.DealerCode} -{opts.OwnerDistributor}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <label class="select-label"> نوع التحويل</label>
            </div>
            {loginInput.distributor_id == "" ? (
              <div style={{ color: "red", fontSize: "10px", textAlign: "end" }}>
                {errors.distributor_id}
              </div>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loading === true ? (
            <Controls.Button
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <Controls.Button
              type="submit"
              text="إضافة"
              onClick={addForm}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          )}
        </Grid>
      </Form>
    </div>
  );
}
